module.exports = __webpack_public_path__ + "static/media/bron3.49cd243b.jpg";